/* eslint-disable */
import n from './r1.js'
import s from './c11.js'
import ck1 from './ck1.js'
import o from './ck2.js'

var l = function () {
  function i(e) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, i);
    this.options = (0,
      s.merge)({
        verbose: !0,
        cpu: !1,
        gpu: !1,
        callback: null
      }, e);
    var t = new ck1(window.navigator.userAgent);
    window.isMobile = null !== t.phone(),
      window.isTablet = null !== t.tablet(),
      window.isDesktop = !window.isTablet && !window.isMobile,
      this.device = window.isMobile ? "mobile" : window.isTablet ? "tablet" : "desktop",
      document.body.classList.add(this.device);
    var n = window.navigator.userAgent.toLowerCase();
    window.isIE = -1 !== this.getInternetExplorerVersion(),
      window.isOpera = -1 < n.indexOf("opr/"),
      window.isChrome = !window.isOpera && (-1 < n.indexOf("chrome") || -1 < n.indexOf("crios")),
      window.isSafari = !window.isOpera && !window.isChrome && -1 < n.indexOf("safari"),
      window.isFirefox = -1 < n.indexOf("firefox"),
      window.isEdge = -1 < n.indexOf("edge"),
      this.browser = this.getBrowser(),
      document.body.classList.add(this.browser),
      window.isWebGL = this.webGLAvailability(),
      window.isWebGL && this.options.gpu && (this.gpu = new o.default({
        verbose: !1
      })),
      // this.options.cpu && (this.cpu = new a.default({
      //   verbose: !1,
      //   callback: this.report.bind(this)
      // }),
      //   this.cpu.run()),
      !this.options.cpu && this.options.verbose && this.report()
  }
  return n(i, null, [{
    key: "check",
    value: function (e) {
      i.instance || (i.instance = new i(e))
    }
  }]),
    n(i, [{
      key: "report",
      value: function () {
        this.options.verbose && (this.gpu && this.gpu.logReport(),
          this.cpu && this.cpu.logReport(),
          this.options.callback && this.options.callback())
      }
    }, {
      key: "getInternetExplorerVersion",
      value: function () {
        var e = -1
          , t = window.navigator.userAgent;
        return "Microsoft Internet Explorer" === window.navigator.appName ? null !== new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})").exec(t) && (e = parseFloat(RegExp.$1)) : "Netscape" === window.navigator.appName && null !== new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})").exec(t) && (e = parseFloat(RegExp.$1)),
          e
      }
    }, {
      key: "getBrowser",
      value: function () {
        var e = {
          ie: window.isIE,
          opera: window.isOpera,
          chrome: window.isChrome,
          safari: window.isSafari,
          firefox: window.isFirefox,
          edge: window.isEdge
        };
        for (var t in e)
          if (Boolean(e[t]))
            return t;
        return "unknown"
      }
    }, {
      key: "webGLAvailability",
      value: function () {
        try {
          var e = document.createElement("canvas");
          return !(!window.WebGLRenderingContext || !e.getContext("webgl") && !e.getContext("experimental-webgl"))
        } catch (e) {
          return !1
        }
      }
    }]),
    i
}();
var t = { default: l }

export default t
